var render = function render(){var _vm=this,_c=_vm._self._c;return _c('page-view',[_c('template',{slot:"action"}),_c('a-card',[_c('expertFees-STable',{attrs:{"expertId":_vm.expertId,"startDate":_vm.startDate,"endDate":_vm.endDate}})],1)],2)
}
var staticRenderFns = []

export { render, staticRenderFns }